import {
    TFundingRequirement,
    TIdVerificationPerson
} from './fundingRequirements.types';

// The first person on the id_verification requirement who still has to send their ID check SMS.
export const getIdVerificationPersonToVerify = ({
    people = []
}: TFundingRequirement): TIdVerificationPerson | undefined =>
    people.find(({ status }) => status === 'action_needed');
